import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { bindAll, DOM } from '@antv/l7-utils';
import Control, { PositionType } from './BaseControl';

var Zoom = function (_Control) {
  _inherits(Zoom, _Control);

  var _super = _createSuper(Zoom);

  function Zoom(cfg) {
    var _this;

    _classCallCheck(this, Zoom);

    _this = _super.call(this, cfg);

    _defineProperty(_assertThisInitialized(_this), "disabled", void 0);

    _defineProperty(_assertThisInitialized(_this), "zoomInButton", void 0);

    _defineProperty(_assertThisInitialized(_this), "zoomOutButton", void 0);

    bindAll(['updateDisabled', 'zoomIn', 'zoomOut'], _assertThisInitialized(_this));
    return _this;
  }

  _createClass(Zoom, [{
    key: "getDefault",
    value: function getDefault() {
      return {
        position: PositionType.TOPLEFT,
        zoomInText: '+',
        zoomInTitle: 'Zoom in',
        zoomOutText: '&#x2212;',
        zoomOutTitle: 'Zoom out',
        name: 'zoom'
      };
    }
  }, {
    key: "onAdd",
    value: function onAdd() {
      var zoomName = 'l7-control-zoom';
      var container = DOM.create('div', zoomName + ' l7-bar');
      this.zoomInButton = this.createButton(this.controlOption.zoomInText, this.controlOption.zoomInTitle, zoomName + '-in', container, this.zoomIn);
      this.zoomOutButton = this.createButton(this.controlOption.zoomOutText, this.controlOption.zoomOutTitle, zoomName + '-out', container, this.zoomOut);
      this.mapsService.on('zoomend', this.updateDisabled);
      this.mapsService.on('zoomchange', this.updateDisabled);
      this.updateDisabled();
      return container;
    }
  }, {
    key: "onRemove",
    value: function onRemove() {
      this.mapsService.off('zoomend', this.updateDisabled);
      this.mapsService.off('zoomchange', this.updateDisabled);
    }
  }, {
    key: "disable",
    value: function disable() {
      this.disabled = true;
      this.updateDisabled();
      return this;
    }
  }, {
    key: "enable",
    value: function enable() {
      this.disabled = false;
      this.updateDisabled();
      return this;
    }
  }, {
    key: "zoomIn",
    value: function zoomIn() {
      if (!this.disabled && this.mapsService.getZoom() < this.mapsService.getMaxZoom()) {
        this.mapsService.zoomIn();
      }
    }
  }, {
    key: "zoomOut",
    value: function zoomOut() {
      if (!this.disabled && this.mapsService.getZoom() > this.mapsService.getMinZoom()) {
        this.mapsService.zoomOut();
      }
    }
  }, {
    key: "createButton",
    value: function createButton(html, tile, className, container, fn) {
      var link = DOM.create('a', className, container);
      link.innerHTML = html;
      link.title = tile;
      link.href = 'javascript:void(0)';
      link.addEventListener('click', fn);
      return link;
    }
  }, {
    key: "updateDisabled",
    value: function updateDisabled() {
      var mapsService = this.mapsService;
      var className = 'l7-disabled';
      DOM.removeClass(this.zoomInButton, className);
      DOM.removeClass(this.zoomOutButton, className);

      if (this.disabled || mapsService.getZoom() <= mapsService.getMinZoom()) {
        DOM.addClass(this.zoomOutButton, className);
      }

      if (this.disabled || mapsService.getZoom() >= mapsService.getMaxZoom()) {
        DOM.addClass(this.zoomInButton, className);
      }
    }
  }]);

  return Zoom;
}(Control);

export { Zoom as default };
//# sourceMappingURL=zoom.js.map